// Risk band badge — DESIGN-SYSTEM.md §Risk Band Colours.
// Critical band pulses to draw urgent attention.
import type { JSX } from "react";

const BAND_STYLES: Record<string, string> = {
  Green:    "bg-emerald-100 text-emerald-700",
  Amber:    "bg-amber-100 text-amber-700",
  Red:      "bg-red-100 text-red-700",
  Critical: "bg-rose-100 text-rose-800 animate-pulse",
};

interface Props { band: string | null; }

export function RiskBadge({ band }: Props): JSX.Element {
  if (!band) return <span className="text-slate-400 text-xs">—</span>;
  const cls = BAND_STYLES[band] ?? "bg-slate-100 text-slate-600";
  return (
    <span className={`inline-flex items-center rounded-full px-2 py-0.5 text-xs font-medium ${cls}`}>
      {band}
    </span>
  );
}
